import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const census = defineConnector({
  identifier: "census",
  name: "Census",
  tagLine: "Reverse ETL and audience syncing",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://app\\.getcensus\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Census](https://app.getcensus.com/), open **Workspace Settings › API Access** and create a token.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          placeholder: "secret-token:...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.getcensus.com/api/v1/syncs",
  },
});
